import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Per } from 'ep-bt-field-agent-proxy';

@Component({
  selector: 'epbt-fa-per-list',
  templateUrl: './epbt-fa-per-list.component.html',
  styleUrls: ['./epbt-fa-per-list.component.scss']
})
export class EpbtFaPerListComponent implements OnInit {

  @Input() perList: Per[] = [];
  @Input() labelText: string = "";
  private _selectedPer: number;
  @Input('selectedPer') set selectedPer(value: number) {
    this._selectedPer = value;
    if (this._selectedPer) {
      var result = this.perList.filter(x => x.perId == this._selectedPer);
      this.perChange.emit(result ? result[0] : null);
    }
  }
  get selectedPer(): number {
    return this._selectedPer;
  }

  @Output() perChange = new EventEmitter<any>();
  @Input() disabled = false;

  constructor() { }

  ngOnInit() {
  }

  onSelectionChange(selectedValue: any) {
    if (selectedValue) {
      this.selectedPer = selectedValue.perId;
      var result = this.perList.filter(x => x.perId == this.selectedPer);
      this.perChange.emit(result ? result[0] : null);
    }
  }
}
